export class AdjustmentsModel {
    constructor(
        
        public commissionPeriod: number,
        public sales_rep_channel:string,
        public commission_plan: number,
        public sc_emp_id:number,
        public adjustment_id:number,
        public name: string,
        public user_type:string, 
        public sales_rep_id: string,
        public assc_corps: string,
        
        public employee_id:any,
        public soft_termination_date:Date,
        public operator_id:string,
        public sales_rep_type:string,
        public kpi: string,
        public fixedDollarAmt: string,
        public newTier: string,
        public comments: string,
        public editMode: boolean

        
        
        
        
    ) { }
}
